import Text from "./Text";

export default Text;



// WEBPACK FOOTER //
// /Users/pauloamgomes/Sites/CockpitReactStatic/react-app/src/components/cockpit/Text/index.js